import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import PageTop from "../../sections/PageTop";
import DoctorsList from "./sections/DoctorsList";
// import MainReview from "../main/sections/MainReview";
import AboutClinicForm from "../aboutClinic/sections/AboutClinicForm";
import Location from "../../sections/Location";

const linkChain = [
  {
    id: uuidv4(),
    title: "navHome",
    to: "/",
  },
  {
    id: uuidv4(),
    title: "footerAboutDoctor",
  },
];

export default function Doctor() {
  const { t } = useTranslation();

  return (
    <StyledDoctor>
      <PageTop title={t("doctorTitle")} linkList={linkChain} />
      <DoctorsList />
      {/* <MainReview /> */}
      <AboutClinicForm />
      <Location />
    </StyledDoctor>
  );
}

const StyledDoctor = styled.main``;
